export default __webpack_public_path__ + "static/media/smart-weight.ea500968.png";